jQuery(function ($) {
    // Global shared function to load validation.js only once
    // This prevents multiple scripts from loading it simultaneously
    if (typeof window.loadValidationScript === 'undefined') {
        window.loadValidationScript = function(callback) {
            if (window.InputValidator) {
                // Already loaded, execute callback immediately
                if (typeof callback === 'function') {
                    callback();
                }
            } else if (window._validationScriptLoading) {
                // Script is currently loading, wait for it
                const checkInterval = setInterval(function() {
                    if (window.InputValidator) {
                        clearInterval(checkInterval);
                        delete window._validationScriptLoading;
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                }, 50);
            } else {
                // Start loading
                window._validationScriptLoading = true;
                $.getScript("/assets/frontend/js/validation.js", function() {
                    delete window._validationScriptLoading;
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }
        };
    }

    // Clean up Selectize hidden elements
    function cleanupSelectizeHiddenElements() {
        // Remove Selectize hidden measurement elements
        $('div[style*="position: absolute"][style*="width: 0px"][style*="height: 0px"][style*="overflow: hidden"]').remove();
        $('div[aria-hidden="true"][style*="position: absolute"][style*="width: 0px"]').remove();
    }

    let selectizeCleanupScheduled = false;
    const scheduleSelectizeCleanup = function () {
        if (selectizeCleanupScheduled) {
            return;
        }
        selectizeCleanupScheduled = true;
        const runner = function () {
            selectizeCleanupScheduled = false;
            cleanupSelectizeHiddenElements();
        };
        if (window.requestIdleCallback) {
            window.requestIdleCallback(runner, {timeout: 300});
        } else {
            window.setTimeout(runner, 60);
        }
    };

    // Initial pass and sparse fallback pass (avoid aggressive 1s polling on main thread).
    $(window).on('load', scheduleSelectizeCleanup);
    $(document).ready(scheduleSelectizeCleanup);
    setInterval(scheduleSelectizeCleanup, 15000);

    // Trigger cleanup when DOM changes likely caused by Selectize redraws.
    if (window.MutationObserver && document.body) {
        const selectizeObserver = new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i++) {
                const m = mutations[i];
                if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
                    scheduleSelectizeCleanup();
                    break;
                }
            }
        });
        selectizeObserver.observe(document.body, {childList: true, subtree: true});
    }

    let html = $("html");
    let body = $("body");
    let modal = $(".modal");
    let header = $(".navbar-header");

    // ---------------------------------------------------------------------
    // Spec help popovers (? icons) - reusable across site (profile + public)
    // ---------------------------------------------------------------------
    if (!window.__carbuySpecHelpInitialized) {
        window.__carbuySpecHelpInitialized = true;

        function closeAllSpecHelp(exceptEl) {
            $('.spec-help.is-open').each(function () {
                if (exceptEl && (this === exceptEl || $.contains(this, exceptEl))) return;
                $(this).removeClass('is-open').find('.spec-help-toggle').attr('aria-expanded', 'false');
            });
        }

        body.on('click', '.spec-help-toggle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $wrap = $(this).closest('.spec-help');
            if (!$wrap.length) return;

            const willOpen = !$wrap.hasClass('is-open');
            closeAllSpecHelp($wrap[0]);
            $wrap.toggleClass('is-open', willOpen);
            $(this).attr('aria-expanded', willOpen ? 'true' : 'false');
        });

        $(document).on('click', function (e) {
            const target = e && e.target ? e.target : null;
            if (!target) return;
            if ($(target).closest('.spec-help').length) return;
            closeAllSpecHelp(null);
        });

        $(document).on('keydown', function (e) {
            if (!e) return;
            if (e.key === 'Escape' || e.key === 'Esc') {
                closeAllSpecHelp(null);
            }
        });
    }



    /*HEIGHT SLIDER TRANSITION*/
    body.on('slide.bs.carousel', '.carousel', function (e) {
        let nextH = $(e.relatedTarget).height();
        $(this).find('.active.carousel-item').parent().animate({
            height: nextH
        }, 500);
    });
    $(window).on('hidden.bs.modal', function () {
        $('.carousel .carousel-inner').css("height", "auto");
    });
    $(window).resize(function () {
        $('.carousel .carousel-inner').css("height", "auto");
    });
    /*END HEIGHT SLIDER TRANSITION*/

    /*SHOW SLIDE BY PREVIEW CLICK*/
    let imageNumber;
    let slideNumber;
    body.on("click", ".slider-image-link", function () {
        imageNumber = $(this).attr('data-counter');
        var targetSel = $(this).attr('data-target');
        var $scope;
        if (targetSel && String(targetSel).trim() !== '') {
            var $t = $(targetSel);
            $scope = $t.closest('.image-modal-window');
            if (!$scope.length) {
                $scope = $('.image-modal-window').first();
            }
        } else {
            $scope = $('.image-modal-window').first();
        }
        $scope.find('.carousel-item').each(function () {
            $(this).removeClass('active');
            slideNumber = $(this).attr("data-counter");
            if (slideNumber === imageNumber) {
                $(this).addClass('active');
            }
        });
    });
    /*END SHOW SLIDE BY PREVIEW CLICK*/

    /*CLOSE MODAL FIX*/
    body.on('click', ".image-modal-window .align-modal-helper", function (e) {
        if (e.target !== this) return;
        $(this).parents('.image-modal-window').find('.modal-cross').trigger('click');
    });
    body.on('click', ".image-modal-window .modal-content", function (e) {
        if (e.target !== this) return;
        $(this).parents('.image-modal-window').find('.modal-cross').trigger('click');
    });
    /*CLOSE MODAL FIX*/

    /*OVERFLOW MODAL FIX*/
    modal.on('shown.bs.modal', function () {
        body.removeClass('modal-open');
        html.addClass('modal-open');
    });
    modal.on('hidden.bs.modal', function () {
        html.removeClass('modal-open');
    });
    /*END OVERFLOW MODAL FIX*/

    // MOBILE MENU
    let mobileMenu = $(".mobile-menu");
    let mobileBackground = $(".mobile-background");
    body.on("click", ".burger-toggle", function (e) {
        e.preventDefault();
        mobileMenu.removeClass("d-none");
        mobileBackground.removeClass("d-none");
        setTimeout(function () {
            mobileMenu.toggleClass("mobile-menu-hidden");
            mobileBackground.toggleClass("mobile-background-hidden");
            html.toggleClass('modal-open');
            header.toggleClass('navbar-header-opened');
            if (!mobileMenu.hasClass("mobile-menu-hidden")) {
                getCurrentScrollData();
            } else {
                disablingScrollFreezing();
                setTimeout(function () {
                    mobileMenu.addClass("d-none");
                    mobileBackground.addClass("d-none");
                }, 200);
            }
        }, 10);
    });
    $(window).on("resize", function () {
        if (!mobileMenu.hasClass("mobile-menu-hidden") && $(window).width() > 1280) {
            mobileMenu.addClass("mobile-menu-hidden").addClass("d-none");
            mobileBackground.addClass("mobile-background-hidden").addClass("d-none");
            header.removeClass('navbar-header-opened');
            html.removeClass("modal-open");
            disablingScrollFreezing();
        }
    });
    body.on("click", ".mobile-background", function () {
        mobileMenu.addClass("mobile-menu-hidden");
        mobileBackground.addClass("mobile-background-hidden");
        setTimeout(function () {
            mobileMenu.addClass("d-none");
            mobileBackground.addClass("d-none");
        }, 200);
        html.toggleClass('modal-open');
        header.toggleClass('navbar-header-opened');
    });
    let lastScroll = $(window).scrollTop();
    (lastScroll > 0) ? header.addClass("navbar-scrolled") : header.removeClass("navbar-scrolled");
    let currentScroll;
    $(window).on("scroll", function () {
        currentScroll = $(this).scrollTop();
        (currentScroll > 0) ? header.addClass("navbar-scrolled") : header.removeClass("navbar-scrolled");
    });
    // END MOBILE MENU

    // PREVENT BACKGROUND SCROLL
    let currentWindowScrollPosition;
    let checkCurrentWindowScrollPosition = false;
    window.addEventListener('scroll', function (e) {
        if (checkCurrentWindowScrollPosition === true && currentWindowScrollPosition !== $(document).scrollTop()) {
            e.preventDefault();
        }
    });

    let getCurrentScrollData = function () {
        checkCurrentWindowScrollPosition = true;
        currentWindowScrollPosition = $(document).scrollTop();
    };

    let disablingScrollFreezing = function () {
        checkCurrentWindowScrollPosition = false;
    };
    // END PREVENT BACKGROUND SCROLL

    // PASSWORD VISIBILITY SWITCHER
    body.on("click", ".password-visibility-switcher", function (e) {
        e.preventDefault();
        let currentPasswordSwitcher = $(this);
        if (currentPasswordSwitcher.siblings(".switched-input").attr("type") === "password") {
            currentPasswordSwitcher.siblings(".switched-input").attr("type", "text");
            currentPasswordSwitcher.addClass("password-visible");
        } else if (currentPasswordSwitcher.siblings(".switched-input").attr("type") === "text") {
            currentPasswordSwitcher.siblings(".switched-input").attr("type", "password");
            currentPasswordSwitcher.removeClass("password-visible");
        }
    });
    // END PASSWORD VISIBILITY SWITCHER

    // HEADER PANEL DROPDOWNS
    let currentPanelCellLink;
    body.on("click", ".header-panel-cell-link", function (e) {
        currentPanelCellLink = $(this);
        if (!currentPanelCellLink.siblings(".header-panel-dropdown").length) {
            return;
        }
        // Allow profile shortcut link to work naturally
        if (currentPanelCellLink.hasClass('profile-shortcut-link')) {
            return;
        }

        e.preventDefault();
        $(".header-panel-dropdown").addClass("header-panel-dropdown-hidden");
        if (currentPanelCellLink.hasClass("header-panel-cell-link-active")) {
            currentPanelCellLink.removeClass("header-panel-cell-link-active").siblings(".header-panel-dropdown").addClass("header-panel-dropdown-hidden");
        } else {
            $(".header-panel-cell-link").removeClass("header-panel-cell-link-active");
            currentPanelCellLink.addClass("header-panel-cell-link-active").siblings(".header-panel-dropdown").toggleClass("header-panel-dropdown-hidden");
        }
    });
    $(document).on("click", function (e) {
        if (!$(e.target).closest(".header-panel-cell").length && !$(e.target).is(".header-panel-cell-link")) {
            $(".header-panel-cell-link").removeClass("header-panel-cell-link-active");
            $(".header-panel-dropdown").addClass("header-panel-dropdown-hidden");
        }
    });
    // END HEADER PANEL DROPDOWNS

    // MODE SWITCHER
    body.on("click", ".switch-to-dark-mode", function (e) {
        e.preventDefault();
        body.addClass("dark-mode");
        $(".switch-to-dark-mode").addClass("active-dropdown-item");
        $(".switch-to-light-mode").removeClass("active-dropdown-item");
        setCookie("theme-mode", "dark", 30);
    });
    body.on("click", ".switch-to-light-mode", function (e) {
        e.preventDefault();
        body.removeClass("dark-mode");
        $(".switch-to-light-mode").addClass("active-dropdown-item");
        $(".switch-to-dark-mode").removeClass("active-dropdown-item");
        setCookie("theme-mode", "light", 30);
    });

    // Retrieve saved mode from cookie and apply it
    function applySavedMode() {
        const savedMode = getCookie("theme-mode");
        if (savedMode === "dark") {
            body.addClass("dark-mode");
            $(".switch-to-dark-mode").addClass("active-dropdown-item");
            $(".switch-to-light-mode").removeClass("active-dropdown-item");
        } else {
            body.removeClass("dark-mode");
            $(".switch-to-light-mode").addClass("active-dropdown-item");
            $(".switch-to-dark-mode").removeClass("active-dropdown-item");
        }
    }

    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    // Get the cookie value by name
    function getCookie(name) {
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(name + "=") == 0) {
                return c.substring(name.length + 1, c.length);
            }
        }
        return "";
    }

    applySavedMode();

    // END MODE SWITCHER

    // SCROLL TO AUTH FORM
    body.on("click", ".existed-profile-button", function (e) {
        e.preventDefault();
        let headerHeight = header.outerHeight();
        $('html, body').animate({
            scrollTop: $(".auth-form").offset().top - headerHeight - 24
        }, 1000);
    });
    // END SCROLL TO AUTH FORM

    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------
    // MODALS

    // BANNER MODAL
    body.on("click", ".banner-modal-opener", function (e) {
        e.preventDefault();
        $(".banner-modal").addClass("banner-modal-visible");
        html.addClass('modal-open');
        getCurrentScrollData();
    });
    body.on("click", ".banner-modal-closer", function (e) {
        e.preventDefault();
        closeBannerModal();
    });
    body.on("click", ".banner-modal", function (e) {
        if ($(e.target).hasClass("banner-modal")) closeBannerModal();
    });

    function closeBannerModal() {
        $(".banner-modal").removeClass("banner-modal-visible");
        html.removeClass('modal-open');
        disablingScrollFreezing();
    }

    // END BANNER MODAL

    // CORNER FORM MODAL
    let cornerFormModal;
    body.on("click", ".corner-form-modal-opener", function (e) {
        e.preventDefault();
        cornerFormModal = $(".corner-form-modal");
        cornerFormModal.addClass("corner-form-modal-visible");
        html.addClass('modal-open');
        getCurrentScrollData();
    });
    body.on("click", ".corner-form-modal-closer", function (e) {
        e.preventDefault();
        closeCornerFormModal();
    });
    body.on("click", ".corner-form-modal", function (e) {
        if ($(e.target).hasClass("corner-form-modal")) closeCornerFormModal();
    });

    function closeCornerFormModal() {
        cornerFormModal.removeClass("corner-form-modal-visible");
        html.removeClass('modal-open');
        disablingScrollFreezing();
    }

    // END CORNER FORM MODAL

    // CENTER FORM MODAL
    let centerFormModal;
    body.on("click", ".center-form-modal-opener", function (e) {
        e.preventDefault();
        centerFormModal = $(".center-form-modal");
        
        if (centerFormModal.length === 0) {
            return;
        }
        
        // Check if this opener has car / trailer data attributes.
        // Keep IDs even when title/price attributes are missing, so backend can still resolve asset data.
        let carId = $(this).data('car-id');
        let carName = $(this).data('car-name');
        let carPrice = $(this).data('car-price');
        let carImage = $(this).data('car-image');

        let trailerId = $(this).data('trailer-id');
        let trailerName = $(this).data('trailer-name');
        let trailerPrice = $(this).data('trailer-price');
        let trailerImage = $(this).data('trailer-image');

        const normalizedCarId = parseInt(String(carId ?? ''), 10);
        const normalizedTrailerId = parseInt(String(trailerId ?? ''), 10);
        carId = Number.isFinite(normalizedCarId) && normalizedCarId > 0 ? normalizedCarId : null;
        trailerId = Number.isFinite(normalizedTrailerId) && normalizedTrailerId > 0 ? normalizedTrailerId : null;

        // Special handling for calculator submit button: get price from slider
        if ($(this).hasClass('calculator-submit-button')) {
            // Get the current price from the calculator slider input (raw value)
            let sliderPrice = $('#calculator-price').attr('data-int-value');
            if (sliderPrice) {
                // Format with spaces for thousands
                const formatted = sliderPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                if (carId) carPrice = formatted;
                if (trailerId) trailerPrice = formatted;
            }
        }
        
        // Get modal elements
        let carDataSection = $("#center-modal-car-data");
        let modalContext = $("#center-modal-context");
        let modalCarId = $("#center-modal-car-id");
        let modalTrailerId = $("#center-modal-trailer-id");
        
        // Capture calculator values when opening modal (from page calculator)
        const calculatorPrice = $('#calculator-price');
        const calculatorTerm = $('#calculator-term');
        let calculatorTotalPrice = null;
        let calculatorTermValue = null;
        
        if (calculatorPrice.length && calculatorPrice.attr('data-int-value')) {
            calculatorTotalPrice = calculatorPrice.attr('data-int-value');
        }
        
        if (calculatorTerm.length && calculatorTerm.attr('data-int-value')) {
            calculatorTermValue = calculatorTerm.attr('data-int-value');
        }
        
        // Store calculator values in hidden inputs in the modal form for later retrieval
        let modalForm = $("#center-modal-form");
        if (modalForm.length) {
            // Remove existing hidden inputs if any
            modalForm.find('input[name="calculator_total_price"]').remove();
            modalForm.find('input[name="calculator_term"]').remove();
            
            // Add hidden inputs with calculator values
            if (calculatorTotalPrice) {
                modalForm.append('<input type="hidden" name="calculator_total_price" value="' + calculatorTotalPrice + '">');
            }
            if (calculatorTermValue) {
                modalForm.append('<input type="hidden" name="calculator_term" value="' + calculatorTermValue + '">');
            }
        }
        
        if (carId) {
            // Show selected asset block only when enough display data is available.
            if (carName && carPrice) {
                carDataSection.removeClass('d-none').addClass('d-flex');
                carDataSection.find('.form-modal-selected-data-title').text('Automašina: ' + carName);
                carDataSection.find('.form-modal-selected-data-price').text('Cena: ' + carPrice + ' €');
                if (carImage) {
                    carDataSection.find('.form-modal-selected-data-image img').attr('src', carImage);
                }
            } else {
                carDataSection.removeClass('d-flex').addClass('d-none');
            }

            // Set context and car ID for form submission
            modalContext.val('car');
            modalCarId.val(String(carId));
            if (modalTrailerId.length) modalTrailerId.val('');
        } else if (trailerId) {
            // Show selected asset block only when enough display data is available.
            if (trailerName && trailerPrice) {
                carDataSection.removeClass('d-none').addClass('d-flex');
                carDataSection.find('.form-modal-selected-data-title').text('Piekabe: ' + trailerName);
                carDataSection.find('.form-modal-selected-data-price').text('Cena: ' + trailerPrice + ' €');
                if (trailerImage) {
                    carDataSection.find('.form-modal-selected-data-image img').attr('src', trailerImage);
                }
            } else {
                carDataSection.removeClass('d-flex').addClass('d-none');
            }

            // Set context and trailer ID for form submission
            modalContext.val('trailer');
            modalCarId.val('');
            if (modalTrailerId.length) modalTrailerId.val(String(trailerId));
        } else {
            // Hide car data section for general leasing inquiries
            carDataSection.removeClass('d-flex').addClass('d-none');
            modalContext.val('general');
            modalCarId.val('');
            if (modalTrailerId.length) modalTrailerId.val('');
        }
        
        if (carId) {
            const $opener = $(this);
            const sellerScope = $opener.attr('data-seller-scope')
                || $opener.attr('data-client-scope')
                || (($opener.attr('data-client-id') && String($opener.attr('data-client-id')) !== '0') ? 'client' : '')
                || '';
            const modalPricing = registerLeasingModalVehicleContext(carId, carName, carPrice, calculatorTotalPrice, sellerScope);
            window.CarBuyLeasingModalContext = Object.assign({ car_id: carId, seller_scope: sellerScope || 'carbuy' }, modalPricing);
            trackLeasingModalOpen(carId, modalPricing);
        }

        // Show modal
        centerFormModal.addClass("center-form-modal-visible");
        body.addClass("center-form-modal-body-visible");
        html.addClass('modal-open');
        getCurrentScrollData();
    });
    body.on("click", ".center-form-modal-closer", function (e) {
        e.preventDefault();
        closeCenterFormModal();
    });
    body.on("click", ".center-form-modal", function (e) {
        if ($(e.target).hasClass("center-form-modal")) closeCenterFormModal();
    });

    function closeCenterFormModal() {
        centerFormModal.removeClass("center-form-modal-visible");
        body.removeClass("center-form-modal-body-visible");
        html.removeClass('modal-open');
        disablingScrollFreezing();
    }

    // END CENTER FORM MODAL



    // MODALS
    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------

    // --- GLOBAL SCROLL RESTORE FIX FOR CATALOG ---
    // If not on catalog page, clear catalog scroll state and scroll to top
    $(document).ready(function() {
        // Initialize CSRF token on page load
        const csrfData = window.CSRFHelper.getCSRFData();
        
        if (window.location.pathname.indexOf('/catalog') === -1) {
            if (typeof window.carbuyClearCatalogSessionStorage === 'function') {
                window.carbuyClearCatalogSessionStorage();
            } else {
                try {
                    ['catalogScroll', 'catalogPage', 'catalogFilters', 'catalogCarsHtml', 'catalogHasMore', 'catalogContentLang'].forEach(function (k) {
                        sessionStorage.removeItem(k);
                    });
                } catch (e) {}
            }
            window.scrollTo(0, 0);
        }
    });

});

// UNIVERSAL CSRF HELPERS
window.CSRFHelper = {
    /**
     * Get CSRF cookie value (for cookie-based CSRF, this is the source of truth)
     */
    getCSRFCookie: function() {
        try {
            const cookieName = 'carbuy_csrf_cookie';
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].trim();
                if (cookie.indexOf(cookieName + '=') === 0) {
                    return cookie.substring(cookieName.length + 1);
                }
            }
            return '';
        } catch (error) {
            return '';
        }
    },
    
    getCSRFData: function() {
        try {
            // For cookie-based CSRF, prefer cookie value (it's the source of truth)
            const cookieValue = this.getCSRFCookie();
            if (cookieValue && cookieValue.length >= 32) {
                return { name: 'carbuy_csrf', value: cookieValue };
            }
            
            // Fallback to meta tags
            const nameElement = document.querySelector('meta[name="csrf-token-name"]');
            const valueElement = document.querySelector('meta[name="csrf-token"]');
            
            if (!nameElement || !valueElement) {
                return { name: 'carbuy_csrf', value: '' };
            }
            
            const name = nameElement.getAttribute('content');
            const value = valueElement.getAttribute('content');
            
            if (!name || !value) {
                return { name: 'carbuy_csrf', value: '' };
            }
            
            // Validate token format (should be 32+ characters)
            if (value.length < 32) {
                return { name: 'carbuy_csrf', value: '' };
            }
            
            return { name, value };
        } catch (error) {
            return { name: 'carbuy_csrf', value: '' };
        }
    },
    setCSRFData: function(name, value) {
        try {
            const nameElement = document.querySelector('meta[name="csrf-token-name"]');
            const valueElement = document.querySelector('meta[name="csrf-token"]');
            
            if (nameElement && valueElement) {
                nameElement.setAttribute('content', name);
                valueElement.setAttribute('content', value);
            }
        } catch (error) {
            // Failed to set CSRF data
        }
    },
    validateCSRFToken: function() {
        const token = this.getCSRFData().value;
        return token && token.length >= 32;
    },
    
    injectCSRF: function(formData) {
        const csrfData = this.getCSRFData();
        if (csrfData.value) {
            if (formData instanceof FormData) {
                formData.append(csrfData.name, csrfData.value);
            } else if (typeof formData === 'object' && formData !== null) {
                // Handle plain objects
                formData[csrfData.name] = csrfData.value;
            }
        }
        return formData;
    },
    
    updateCSRFMeta: function(response) {
        if (response && response.csrf_hash && response.csrf_name) {
            this.setCSRFData(response.csrf_name, response.csrf_hash);
        }
    },
    
    refreshCSRFToken: function() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/ajax/get-csrf-token',
                type: 'GET',
                dataType: 'json',
                headers: { 'Accept': 'application/json' },
                success: function(response) {
                    if (response.csrf_hash && response.csrf_name) {
                        window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                        resolve({ csrf_name: response.csrf_name, csrf_hash: response.csrf_hash });
                    } else {
                        reject('Invalid CSRF response');
                    }
                },
                error: function() {
                    reject('Failed to refresh CSRF token');
                }
            });
        });
    }

};

// SIMPLIFIED CSRF-safe AJAX POST - Uses cookie-based CSRF token
// For cookie-based CSRF, we MUST use the token from the cookie (not fetch a new one)
// The POST token must match the cookie token exactly
function csrfSafeAjaxPost(url, data, successCallback, errorCallback, completeCallback, csrfRetryAttempt) {
    csrfRetryAttempt = csrfRetryAttempt || 0;
    // Get CSRF token from cookie (source of truth for cookie-based CSRF)
    let csrfName = 'carbuy_csrf';
    let csrfHash = window.CSRFHelper.getCSRFCookie();
    
    // If cookie not found, try to get from meta tags or fetch fresh token
    if (!csrfHash || csrfHash.length < 32) {
        const csrfData = window.CSRFHelper.getCSRFData();
        if (csrfData && csrfData.value && csrfData.value.length >= 32) {
            csrfName = csrfData.name;
            csrfHash = csrfData.value;
        } else {
            // Last resort: fetch fresh token (but this may cause mismatch if cookie isn't updated)
            $.ajax({
                url: '/ajax/get-csrf-token',
                type: 'GET',
                dataType: 'json',
                cache: false,
                headers: { 'Accept': 'application/json' },
                async: false // Synchronous to ensure we have token before proceeding
            }).done(function(csrfResponse) {
                if (csrfResponse && csrfResponse.csrf_hash && csrfResponse.csrf_name) {
                    csrfName = csrfResponse.csrf_name;
                    csrfHash = csrfResponse.csrf_hash;
                    window.CSRFHelper.setCSRFData(csrfName, csrfHash);
                }
            });
            
            // If still no token, fail
            if (!csrfHash || csrfHash.length < 32) {
                console.error('Failed to get CSRF token');
                if (errorCallback) errorCallback(null, 'error', 'Failed to get CSRF token');
                return;
            }
        }
    }
    
    // Prepare request data with CSRF token from cookie
    let requestData = data;
    
    if (data instanceof FormData) {
        // Remove any existing CSRF tokens
        data.delete(csrfName);
        data.delete('csrf_test_name');
        data.delete('csrf_hash');
        data.delete('csrf_name');
        data.delete('carbuy_csrf');
        // Add token from cookie
        data.append(csrfName, csrfHash);
        requestData = data;
    } else if (typeof data === 'object' && data !== null) {
        // Remove any existing CSRF tokens
        requestData = Object.assign({}, data);
        delete requestData[csrfName];
        delete requestData['csrf_test_name'];
        delete requestData['csrf_hash'];
        delete requestData['csrf_name'];
        delete requestData['carbuy_csrf'];
        // Add token from cookie
        requestData[csrfName] = csrfHash;
    } else if (typeof data === 'string') {
        // Remove any existing CSRF tokens
        requestData = data.replace(new RegExp('(?:^|&)' + encodeURIComponent(csrfName) + '=[^&]*', 'g'), '');
        requestData = requestData.replace(/(?:^|&)csrf_test_name=[^&]*/g, '');
        requestData = requestData.replace(/(?:^|&)csrf_hash=[^&]*/g, '');
        requestData = requestData.replace(/(?:^|&)csrf_name=[^&]*/g, '');
        requestData = requestData.replace(/(?:^|&)carbuy_csrf=[^&]*/g, '');
        requestData = requestData.replace(/&+/g, '&').replace(/^&|&$/g, '');
        // Add token from cookie
        requestData += (requestData ? '&' : '') + encodeURIComponent(csrfName) + '=' + encodeURIComponent(csrfHash);
    } else {
        // Fallback: create object with CSRF token
        requestData = {};
        requestData[csrfName] = csrfHash;
    }
    
    // Send POST request with CSRF token (body + header fallback)
    return $.ajax({
            url: url,
            type: 'POST',
            data: requestData,
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': csrfHash
            },
            processData: !(data instanceof FormData),
            contentType: data instanceof FormData ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
            success: function(response) {
                // Update CSRF token from response
                if (response && response.csrf_hash && response.csrf_name) {
                    window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                }
                if (successCallback) successCallback(response);
            },
            error: function(xhr, status, error) {
                // Update CSRF token from error response if available
                try {
                    const response = xhr.responseJSON || {};
                    if (response.csrf_hash && response.csrf_name) {
                        window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                    }
                } catch (e) {}

                // Stale meta vs cookie, expired session cookie, or tab left open: one refresh + retry
                if (xhr.status === 403 && csrfRetryAttempt < 1 &&
                    window.CSRFHelper && typeof window.CSRFHelper.refreshCSRFToken === 'function') {
                    window.CSRFHelper.refreshCSRFToken()
                        .then(function () {
                            csrfSafeAjaxPost(url, data, successCallback, errorCallback, completeCallback, csrfRetryAttempt + 1);
                        })
                        .catch(function () {
                            window.UniversalHelpers.handleCsrfError();
                            if (errorCallback) errorCallback(xhr, status, error);
                        });
                    return;
                }

                if (xhr.status === 403) {
                    window.UniversalHelpers.handleCsrfError();
                }
                if (errorCallback) errorCallback(xhr, status, error);
            },
            complete: function(xhr) {
                // Update CSRF token from response (backup)
                try {
                    const response = xhr.responseJSON || {};
                    if (response.csrf_hash && response.csrf_name) {
                        window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
                    }
                } catch (e) {}
                
                if (completeCallback) completeCallback(xhr);
            }
        });
}
// Expose for scripts that expect it on window (e.g. center-modal-form, leasing, profile)
window.csrfSafeAjaxPost = csrfSafeAjaxPost;

// UNIVERSAL UTILITY FUNCTIONS
window.UniversalHelpers = {

    // Universal CSRF error handler
    handleCsrfError: function(warningBoxSelector = ".warning-messages") {
        const $warningBox = $(warningBoxSelector);
        $warningBox.empty().html('Sesija ir beigusies. Lūdzu atsvaidziniet lapu un mēģiniet vēlreiz.').show();
        
        // Scroll to error message
        $('html, body').animate({
            scrollTop: $warningBox.offset().top - 100
        }, 500);

        // Don't auto-reload - let user decide when to refresh
        // setTimeout(function() {
        //     window.location.reload();
        // }, 3000);
    },

    // Universal CSRF token validator
    validateCsrfToken: function() {
        const token = window.CSRFHelper.getCSRFData().value;
        if (!token) {
            this.handleCsrfError();
            return false;
        }
        return true;
    },

    // Universal model loading functions
    loadModelsByMake: function(makeId, modelSelectName = 'form-catalog-model', endpoint = '/ajax/get-models') {
        const modelSelect = $(`select[name="${modelSelectName}"]`)[0]?.selectize;
        if (!modelSelect) return;
        const data = { make_id: makeId };
        csrfSafeAjaxPost(endpoint, data, function(response) {
            if (response.success && response.models) {
                modelSelect.clearOptions();
                const allText = (window.catalogTranslations && window.catalogTranslations.all) ? window.catalogTranslations.all : 'Visi';
                const options = [{ value: 'all', text: allText, slug: '' }];

                if (response.grouped && response.optgroups && response.optgroups.length) {
                    response.optgroups.forEach(function(grp) {
                        if (modelSelect.addOptionGroup) {
                            modelSelect.addOptionGroup(grp.id, { label: grp.label });
                        }
                    });
                    response.models.forEach(function(model) {
                        options.push({
                            value: model.id,
                            text: model.name,
                            slug: model.slug || '',
                            optgroup: model.optgroup || null
                        });
                    });
                } else {
                    response.models.forEach(function(model) {
                        options.push({
                            value: model.id,
                            text: model.name,
                            slug: model.slug || ''
                        });
                    });
                }

                modelSelect.addOption(options);
                modelSelect.refreshOptions(false);
                modelSelect.setValue('all', true);
                modelSelect.enable();
            } else {
                modelSelect.clearOptions();
                modelSelect.disable();
            }
        }, function(xhr, status, error) {
            modelSelect.clearOptions();
            modelSelect.disable();
        });
    },

    loadModelsByMakeAndCategory: function(makeId, category, modelSelectName = 'form-home-filters-model') {
        const modelSelect = $(`select[name="${modelSelectName}"]`)[0].selectize;
        if (!modelSelect) return;

        const data = { 
            make_id: makeId,
            category: category || 'cars'
        };
        csrfSafeAjaxPost('/ajax/get-models', data, 
            function(response) {
                if (response.success && response.models) {
                    modelSelect.clearOptions();
                    modelSelect.addOption({ value: 'all', text: 'All models' });
                    response.models.forEach(function(model) {
                        modelSelect.addOption({
                            value: model.id,
                            text: model.name
                        });
                    });
                    modelSelect.setValue('all', true);
                    modelSelect.enable();
                }
            },
            function(xhr) {
                if (xhr.status === 403) {
                    this.handleCsrfError();
                }
            }.bind(this)
        );
    },


    // Universal image order updater
    updateImageOrder: function(wrapperSelector = '.add-advertisement-form-image-input-wrapper', carIdSelector = 'input[name="car_id"]') {
        const imageOrder = [];
        $(wrapperSelector).each(function(index) {
            const $wrapper = $(this);
            const $img = $wrapper.find('.selected-image');
            if ($img.length) {
                imageOrder.push({
                    src: $img.attr('src'),
                    position: index + 1
                });
            }
        });
        
        const carId = $(carIdSelector).val();
        if (carId) {
            const data = {
                car_id: carId,
                image_order: JSON.stringify(imageOrder)
            };
            csrfSafeAjaxPost('/profile/update-image-order', data, 
                function(response) {
                    // Image order updated
                },
                function(xhr) {
                    if (xhr.status === 403) {
                        this.handleCsrfError();
                    }
                }.bind(this)
            );
        }
    },

    // Universal error clearer
    clearErrors: function(warningBoxSelector, inputWrapperSelector, messageSelector) {
        $(warningBoxSelector).hide();
        $(inputWrapperSelector).removeClass('input-warning');
        $(messageSelector).hide();
    },

    // Universal clipboard copy function
    copyToClipboard: function(text) {
        return new Promise((resolve, reject) => {
            // Method 1: Modern Clipboard API (requires HTTPS)
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(resolve).catch(() => {
                    // Fallback to Method 2
                    this.fallbackCopyTextToClipboard(text, resolve, reject);
                });
            } else {
                // Fallback to Method 2
                this.fallbackCopyTextToClipboard(text, resolve, reject);
            }
        });
    },

    // Fallback copy method for HTTP or older browsers
    fallbackCopyTextToClipboard: function(text, resolve, reject) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            if (successful) {
                resolve();
            } else {
                reject(new Error('Copy command was unsuccessful'));
            }
        } catch (err) {
            document.body.removeChild(textArea);
            reject(err);
        }
    },

    // Universal make/model loading system
    loadMakesByType: function(type = 'cars', makeSelectName = 'car-brand', callback = null) {
        const makeSelect = $(`select[name="${makeSelectName}"]`)[0]?.selectize;
        if (!makeSelect) return;

        const data = { type: type };
        csrfSafeAjaxPost('/ajax/get-makes', data,
            function(response) {
                if (response.success && response.makes) {
                    makeSelect.clearOptions();
                    makeSelect.addOption({ value: '', text: 'Izvēlies marku', type: type });
                    response.makes.forEach(function(make) {
                        makeSelect.addOption({
                            value: make.id,
                            text: make.name,
                            type: type
                        });
                    });
                    makeSelect.setValue('', true);
                    makeSelect.enable();
                    if (callback) callback();
                }
            },
            function(xhr) {
                if (xhr.status === 403) {
                    this.handleCsrfError();
                }
            }.bind(this)
        );
    },

    loadModelsByBrand: function(brandId, modelSelectName = 'car-model', callback = null) {
        const modelSelect = $(`select[name="${modelSelectName}"]`)[0]?.selectize;
        if (!modelSelect) return;

        const data = { make_id: brandId };
        // Profile add/edit forms should not expose virtual series options (1series, 2series, ...).
        if (window.location && /^\/profile(\/|$)/.test(window.location.pathname || '')) {
            data.include_series = 0;
        }
        csrfSafeAjaxPost('/ajax/get-models', data,
            function(response) {
                if (response.success && response.models) {
                    modelSelect.clearOptions();
                    modelSelect.addOption({ value: '', text: 'Izvēlies modeli' });
                    response.models.forEach(function(model) {
                        modelSelect.addOption({
                            value: model.id,
                            text: model.name
                        });
                    });
                    modelSelect.setValue('', true);
                    modelSelect.enable();
                    
                    // Call callback if provided (e.g., to restore preselected model)
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
            },
            function(xhr) {
                if (xhr.status === 403) {
                    this.handleCsrfError();
                }
            }.bind(this)
        );
    }
};

// GLOBAL AJAX CSRF SETUP
// NOTE: We do NOT inject CSRF here to avoid conflicts with csrfSafeAjaxPost
// All AJAX POST requests should use csrfSafeAjaxPost() which handles CSRF properly
$.ajaxSetup({
    complete: function(xhr) {
        // Update CSRF token from response JSON if present
        try {
            const response = xhr.responseJSON || {};
            if (response.csrf_hash && response.csrf_name) {
                window.CSRFHelper.setCSRFData(response.csrf_name, response.csrf_hash);
            }
        } catch (e) {}
    },
    error: function(xhr) {
        if (xhr.status === 403) {
            if (window.UniversalHelpers && typeof window.UniversalHelpers.handleCsrfError === 'function') {
                window.UniversalHelpers.handleCsrfError();
            } else {
                alert('Session expired. Please refresh the page.');
                // Don't auto-reload - let user decide
                // window.location.reload();
            }
        }
    }
});

// Example: When make changes, refresh models and cars
$('select[name="make"]').on('change', function() {
    var makeId = $(this).val();
    window.UniversalHelpers.loadModelsByMake(makeId);
    // Now refresh cars
    csrfSafeAjaxPost('/ajax/catalog/get-cars', { make_id: makeId }, function(carResponse) {
        // TODO: Update car list UI with carResponse
        // Example: $('#car-list').html(carResponse.html);
    });
});

// When model changes, refresh cars as well
$('select[name="model"]').on('change', function() {
    var makeId = $('select[name="make"]').val();
    var modelId = $(this).val();
    csrfSafeAjaxPost('/ajax/catalog/get-cars', { make_id: makeId, model_id: modelId }, function(carResponse) {
        // TODO: Update car list UI with carResponse
        // Example: $('#car-list').html(carResponse.html);
    });
});

// -------------------------------------------------------------------------------------------------
// Guest Favorites (localStorage)
// -------------------------------------------------------------------------------------------------
// This is intentionally guest-only (no DB), as requested.
// Pages can render a heart button with `.favorite-toggle[data-car-id="..."]` and we handle the rest.
(function () {
    const STORAGE_KEY = 'carbuy_favorites_v1';
    const TRACK_TOGGLE_URL = '/favorites/event';
    const SERVER_IDS_URL = '/ajax/favorites/ids';
    const SERVER_TOGGLE_URL = '/ajax/favorites/toggle';
    const SERVER_MERGE_URL = '/ajax/favorites/merge';
    const MAX_IDS = 500; // safety cap

    // Filled in by the first /ajax/favorites/ids call. While null, treat the
    // user as guest (localStorage-only) so first paint is always instant.
    let _serverAuthenticated = null;
    let _serverHydrated = false;

    function normalizeId(id) {
        const n = Number(id);
        if (!Number.isFinite(n) || n <= 0) return null;
        return Math.floor(n);
    }

    function readIds() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) return [];
            const out = [];
            const seen = new Set();
            for (const v of parsed) {
                const id = normalizeId(v);
                if (!id || seen.has(id)) continue;
                seen.add(id);
                out.push(id);
                if (out.length >= MAX_IDS) break;
            }
            return out;
        } catch (e) {
            return [];
        }
    }

    function writeIds(ids) {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
            return true;
        } catch (e) {
            return false;
        }
    }

    function setButtonState(btn, isFav) {
        if (!btn) return;
        try {
            const addLabel = btn.getAttribute('data-fav-add') || 'Add to favourites';
            const removeLabel = btn.getAttribute('data-fav-remove') || 'Remove from favourites';
            const label = isFav ? removeLabel : addLabel;
            btn.classList.toggle('is-favorite', !!isFav);
            btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
            btn.setAttribute('aria-label', label);
            btn.setAttribute('title', label);
        } catch (e) {}
    }

    function parseButtonLikesCount(btn) {
        if (!btn) return 0;
        const attrValue = Number(btn.getAttribute('data-likes-count'));
        if (Number.isFinite(attrValue) && attrValue > 0) {
            return Math.floor(attrValue);
        }
        const badge = btn.querySelector ? btn.querySelector('.favorite-like-count') : null;
        if (!badge) return 0;
        const textValue = Number((badge.textContent || '').trim());
        if (!Number.isFinite(textValue) || textValue <= 0) return 0;
        return Math.floor(textValue);
    }

    function setButtonLikesCount(btn, count) {
        if (!btn) return;
        const normalizedCount = Number.isFinite(Number(count))
            ? Math.max(0, Math.floor(Number(count)))
            : 0;
        try {
            btn.setAttribute('data-likes-count', String(normalizedCount));
            const badges = btn.querySelectorAll ? btn.querySelectorAll('.favorite-like-count') : [];
            for (const badge of badges) {
                if (!badge) continue;
                if (normalizedCount > 0) {
                    badge.textContent = String(normalizedCount);
                    badge.classList.remove('is-empty');
                } else {
                    badge.textContent = '';
                    badge.classList.add('is-empty');
                }
            }
        } catch (e) {}
    }

    function syncFavoriteLikesCount(carId, isFavorite) {
        const normalizedId = normalizeId(carId);
        if (!normalizedId || !document.querySelectorAll) return;

        const selector = '.favorite-toggle[data-car-id="' + String(normalizedId) + '"]';
        const buttons = document.querySelectorAll(selector);
        if (!buttons || buttons.length === 0) return;

        let baseCount = 0;
        for (const btn of buttons) {
            const count = parseButtonLikesCount(btn);
            if (count > baseCount) {
                baseCount = count;
            }
        }

        const nextCount = Math.max(0, baseCount + (isFavorite ? 1 : -1));
        for (const btn of buttons) {
            setButtonLikesCount(btn, nextCount);
        }
    }

    function updateHeaderFavoritesCount(ids) {
        try {
            const count = Array.isArray(ids) ? ids.length : readIds().length;
            const text = count > 99 ? '99+' : String(count);
            const badges = document.querySelectorAll ? document.querySelectorAll('.favorites-count-badge') : [];
            for (const badge of badges) {
                if (!badge) continue;
                if (count > 0) {
                    badge.textContent = text;
                    badge.classList.remove('d-none');
                } else {
                    badge.textContent = '';
                    badge.classList.add('d-none');
                }
            }
        } catch (e) {}
    }

    function emitChanged(ids) {
        try {
            updateHeaderFavoritesCount(ids);
            window.dispatchEvent(new CustomEvent('carbuy:favorites:changed', { detail: { ids: ids || [] } }));
        } catch (e) {}
    }

    function getCsrfPair() {
        try {
            if (window.CSRFHelper && typeof window.CSRFHelper.getCSRFData === 'function') {
                const data = window.CSRFHelper.getCSRFData();
                if (data && data.value) return data;
            }
        } catch (e) {}
        try {
            const nameEl = document.querySelector('meta[name="csrf-token-name"]');
            const valueEl = document.querySelector('meta[name="csrf-token"]');
            const name = nameEl ? nameEl.getAttribute('content') : '';
            const value = valueEl ? valueEl.getAttribute('content') : '';
            return { name: name || 'carbuy_csrf', value: value || '' };
        } catch (e) {
            return { name: 'carbuy_csrf', value: '' };
        }
    }

    function applyCsrfFromResponse(json) {
        try {
            if (!json || typeof json !== 'object') return;
            if (json.csrf_hash && json.csrf_name && window.CSRFHelper && typeof window.CSRFHelper.setCSRFData === 'function') {
                window.CSRFHelper.setCSRFData(json.csrf_name, json.csrf_hash);
            }
        } catch (e) {}
    }

    function postJson(url, payload) {
        const csrf = getCsrfPair();
        const body = new URLSearchParams();
        if (payload && typeof payload === 'object') {
            for (const k of Object.keys(payload)) {
                const v = payload[k];
                if (Array.isArray(v)) {
                    for (const item of v) {
                        body.append(k + '[]', String(item));
                    }
                } else if (v !== undefined && v !== null) {
                    body.append(k, String(v));
                }
            }
        }
        if (csrf.value) {
            body.append(csrf.name, csrf.value);
        }
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: body.toString(),
            credentials: 'same-origin'
        }).then(function (res) {
            if (!res.ok) {
                throw new Error('HTTP ' + res.status);
            }
            return res.json();
        }).then(function (json) {
            applyCsrfFromResponse(json);
            return json;
        });
    }

    function getJson(url) {
        return fetch(url, {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin'
        }).then(function (res) {
            if (!res.ok) {
                throw new Error('HTTP ' + res.status);
            }
            return res.json();
        }).then(function (json) {
            applyCsrfFromResponse(json);
            return json;
        });
    }

    function normalizeIdList(value) {
        const out = [];
        const seen = new Set();
        if (Array.isArray(value)) {
            for (const v of value) {
                const nid = normalizeId(v);
                if (!nid || seen.has(nid)) continue;
                seen.add(nid);
                out.push(nid);
                if (out.length >= MAX_IDS) break;
            }
        }
        return out;
    }

    /**
     * Hydrate the local favorites cache from the server. If the response says
     * the user is authenticated, the server is the source of truth and we
     * merge any pre-existing localStorage IDs (guest -> account) before
     * overwriting the local cache.
     */
    function hydrateFromServer() {
        if (_serverHydrated) return Promise.resolve(_serverAuthenticated === true);
        return getJson(SERVER_IDS_URL).then(function (json) {
            const authenticated = !!(json && json.authenticated);
            _serverAuthenticated = authenticated;
            _serverHydrated = true;
            if (!authenticated) {
                return false;
            }
            const serverIds = normalizeIdList(json && json.ids);
            const localIds = readIds();
            const onlyLocal = localIds.filter(function (id) { return serverIds.indexOf(id) === -1; });
            if (onlyLocal.length === 0) {
                writeIds(serverIds);
                emitChanged(serverIds);
                api.sync(document);
                return true;
            }
            // Merge local-only guest IDs into the account, then replace cache.
            return postJson(SERVER_MERGE_URL, { ids: onlyLocal }).then(function (mergeJson) {
                const mergedIds = (mergeJson && mergeJson.success && Array.isArray(mergeJson.ids))
                    ? normalizeIdList(mergeJson.ids)
                    : serverIds.concat(onlyLocal);
                writeIds(mergedIds);
                emitChanged(mergedIds);
                api.sync(document);
                return true;
            }).catch(function () {
                writeIds(serverIds);
                emitChanged(serverIds);
                api.sync(document);
                return true;
            });
        }).catch(function () {
            _serverHydrated = true;
            _serverAuthenticated = false;
            return false;
        });
    }

    /**
     * Server-side toggle for logged-in users. Returns the canonical state from
     * the backend so we can reconcile the optimistic local toggle. Emits
     * analytics server-side, so for logged-in users we DO NOT call
     * trackFavoriteToggle separately.
     */
    function syncToggleWithServer(carId, optimisticIsFavorite) {
        const nid = normalizeId(carId);
        if (!nid) return Promise.resolve(null);
        return postJson(SERVER_TOGGLE_URL, { car_id: nid }).then(function (json) {
            if (!json || json.success !== true) return null;
            const serverIsFav = !!json.is_favorite;
            if (serverIsFav !== optimisticIsFavorite) {
                // Reconcile local cache + UI with server truth.
                const ids = readIds();
                const idx = ids.indexOf(nid);
                if (serverIsFav && idx === -1) {
                    ids.unshift(nid);
                } else if (!serverIsFav && idx >= 0) {
                    ids.splice(idx, 1);
                }
                writeIds(ids);
                emitChanged(ids);
                if (document.querySelectorAll) {
                    const buttons = document.querySelectorAll('.favorite-toggle[data-car-id="' + String(nid) + '"]');
                    for (const b of buttons) setButtonState(b, serverIsFav);
                }
                // Counter delta of 2 to flip the optimistic update.
                syncFavoriteLikesCount(nid, serverIsFav);
                syncFavoriteLikesCount(nid, serverIsFav);
            }
            return json;
        }).catch(function () { return null; });
    }

    function trackFavoriteToggle(carId, isFavorite) {
        const normalizedId = normalizeId(carId);
        if (!normalizedId) return;
        const action = isFavorite ? 'add' : 'remove';
        const payload = {
            car_id: normalizedId,
            action: action
        };
        const query = 'car_id=' + encodeURIComponent(String(normalizedId)) + '&action=' + encodeURIComponent(action);
        const endpointUrl = TRACK_TOGGLE_URL + '?' + query;

        // Prefer sendBeacon for fire-and-forget delivery (works better during quick navigations).
        try {
            if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function' && typeof URLSearchParams === 'function') {
                const beaconBody = new URLSearchParams(payload);
                if (navigator.sendBeacon(endpointUrl, beaconBody)) {
                    return;
                }
            }
        } catch (e) {}

        try {
            if (window.jQuery && typeof window.jQuery.ajax === 'function') {
                window.jQuery.ajax({
                    url: endpointUrl,
                    type: 'POST',
                    data: payload,
                    dataType: 'json',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });
                return;
            }
        } catch (e) {}

        // Fallback for environments where jQuery AJAX is unavailable.
        try {
            if (typeof fetch === 'function') {
                const body = new URLSearchParams(payload).toString();
                fetch(endpointUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: body,
                    credentials: 'same-origin',
                    keepalive: true
                }).catch(function () {});
            }
        } catch (e) {}
    }

    function trackMetaWishlist(carId, isFavorite) {
        if (!isFavorite || !window.CarBuyMetaPixel || typeof window.CarBuyMetaPixel.track !== 'function') {
            return;
        }
        const normalizedId = normalizeId(carId);
        if (!normalizedId) {
            return;
        }
        let payload = { car_id: normalizedId };
        if (typeof window.CarBuyMetaPixel.findVehiclePayloadByCarId === 'function') {
            payload = window.CarBuyMetaPixel.findVehiclePayloadByCarId(normalizedId, payload);
        }
        window.CarBuyMetaPixel.track('AddToWishlist', payload);
    }

    function trackAnalyticsWishlist(carId, isFavorite) {
        if (!isFavorite || !window.CarBuyAnalytics || typeof window.CarBuyAnalytics.track !== 'function') {
            return;
        }
        const normalizedId = normalizeId(carId);
        if (!normalizedId) {
            return;
        }
        let payload = { car_id: normalizedId };
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.findVehiclePayloadByCarId === 'function') {
            payload = window.CarBuyMetaPixel.findVehiclePayloadByCarId(normalizedId, payload);
        }
        window.CarBuyAnalytics.track('add_to_wishlist', payload);
    }

    function parseOpenerPrice(raw) {
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.parseMoneyValue === 'function') {
            return window.CarBuyMetaPixel.parseMoneyValue(raw);
        }
        if (raw === null || raw === undefined || raw === '') {
            return null;
        }
        const num = Number(String(raw).replace(/\s+/g, '').replace(/[^\d]/g, ''));
        return Number.isFinite(num) && num > 0 ? num : null;
    }

    function registerLeasingModalVehicleContext(carId, carName, carPrice, loanAmount, sellerScope) {
        if (!carId || !window.CarBuyMetaPixel || typeof window.CarBuyMetaPixel.registerVehicleContext !== 'function') {
            return { vehicle_price: parseOpenerPrice(carPrice), loan_amount: parseOpenerPrice(loanAmount) };
        }
        const vehiclePrice = parseOpenerPrice(carPrice);
        const parsedLoanAmount = parseOpenerPrice(loanAmount);
        const scope = String(sellerScope || '').toLowerCase() === 'client' ? 'client' : 'carbuy';
        const catalogContentId = (window.CarBuyMetaPixel.resolveCatalogContentId
            ? window.CarBuyMetaPixel.resolveCatalogContentId(carId, { seller_scope: scope })
            : ((scope === 'client' ? 'carbuyclient_' : 'carbuy_') + carId));
        window.CarBuyMetaPixel.registerVehicleContext({
            car_id: carId,
            catalog_content_id: catalogContentId,
            seller_scope: scope,
            name: carName || '',
            price: vehiclePrice || 0,
            loan_amount: parsedLoanAmount || 0,
            currency: 'EUR'
        });
        return {
            vehicle_price: vehiclePrice || '',
            loan_amount: parsedLoanAmount || '',
            catalog_content_id: catalogContentId,
            seller_scope: scope
        };
    }

    function trackLeasingModalOpen(carId, modalPricing) {
        const normalizedId = normalizeId(carId);
        if (!normalizedId) {
            return;
        }
        const pricing = modalPricing || window.CarBuyLeasingModalContext || {};
        let payload = {
            car_id: normalizedId,
            loan_amount: pricing.loan_amount || '',
            vehicle_price: pricing.vehicle_price || ''
        };
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.findVehiclePayloadByCarId === 'function') {
            payload = window.CarBuyMetaPixel.findVehiclePayloadByCarId(normalizedId, payload);
        }
        if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.track === 'function') {
            window.CarBuyAnalytics.track('leasing_form_open', { car_id: normalizedId });
            window.CarBuyAnalytics.track('vehicle_contact_intent', {
                car_id: normalizedId,
                contact_type: 'leasing'
            });
        }
        if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.track === 'function') {
            window.CarBuyMetaPixel.track('InitiateCheckout', Object.assign({}, payload, {
                content_category: 'auto_leasing'
            }));
        }
        if (typeof csrfSafeAjaxPost === 'function') {
            csrfSafeAjaxPost('/ajax/track-leasing-application', { car_id: normalizedId }, function () {});
        }
    }

    const api = {
        key: STORAGE_KEY,
        getIds: () => readIds(),
        has: (id) => {
            const nid = normalizeId(id);
            if (!nid) return false;
            return readIds().includes(nid);
        },
        toggle: (id) => {
            const nid = normalizeId(id);
            if (!nid) return { ok: false, isFavorite: false, ids: readIds() };

            const ids = readIds();
            const idx = ids.indexOf(nid);
            let isFavorite = false;
            if (idx >= 0) {
                ids.splice(idx, 1);
                isFavorite = false;
            } else {
                ids.unshift(nid);
                // cap
                if (ids.length > MAX_IDS) ids.length = MAX_IDS;
                isFavorite = true;
            }

            writeIds(ids);
            emitChanged(ids);
            return { ok: true, isFavorite, ids };
        },
        set: (ids) => {
            const out = [];
            const seen = new Set();
            if (Array.isArray(ids)) {
                for (const v of ids) {
                    const nid = normalizeId(v);
                    if (!nid || seen.has(nid)) continue;
                    seen.add(nid);
                    out.push(nid);
                    if (out.length >= MAX_IDS) break;
                }
            }
            writeIds(out);
            emitChanged(out);
            return out;
        },
        sync: (root) => {
            const ids = readIds();
            const set = new Set(ids);
            const scope = root && root.querySelectorAll ? root : document;
            const buttons = scope.querySelectorAll ? scope.querySelectorAll('.favorite-toggle[data-car-id]') : [];
            for (const btn of buttons) {
                const id = normalizeId(btn.getAttribute('data-car-id'));
                setButtonState(btn, !!(id && set.has(id)));
            }
        },
    };

    // Expose server-sync helpers for callers that need them (e.g. login flow).
    api.hydrateFromServer = hydrateFromServer;
    api.isAuthenticated = function () { return _serverAuthenticated === true; };

    window.CarBuyFavorites = api;

    // Click handler (delegated). Optimistic local toggle, then either:
    //  - logged-in: POST to /ajax/favorites/toggle (handles DB + analytics),
    //  - guest:    POST to /favorites/event (analytics-only, sendBeacon).
    document.addEventListener('click', function (e) {
        const target = e.target;
        if (!target) return;
        const btn = target.closest ? target.closest('.favorite-toggle[data-car-id]') : null;
        if (!btn) return;

        // Prevent navigation when button is overlaying a card/link
        e.preventDefault();
        e.stopPropagation();

        const id = btn.getAttribute('data-car-id');
        const result = api.toggle(id);
        setButtonState(btn, result.isFavorite);
        if (result && result.ok) {
            syncFavoriteLikesCount(id, result.isFavorite);
            trackMetaWishlist(id, result.isFavorite);
            trackAnalyticsWishlist(id, result.isFavorite);
            if (_serverAuthenticated === true) {
                syncToggleWithServer(id, result.isFavorite);
            } else {
                trackFavoriteToggle(id, result.isFavorite);
            }
        }
    }, true);

    // Keep UI in sync across tabs
    window.addEventListener('storage', function (ev) {
        if (!ev || ev.key !== STORAGE_KEY) return;
        api.sync(document);
        emitChanged(readIds());
    });

    // Initial sync for any page that already has buttons in DOM
    try { api.sync(document); } catch (e) {}

    // Initial header count (in case script loads before header markup)
    try {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                updateHeaderFavoritesCount(readIds());
            });
        } else {
            updateHeaderFavoritesCount(readIds());
        }
    } catch (e) {}

    // Hydrate from server in the background. Non-blocking: guest users will
    // simply keep their localStorage IDs, logged-in users will get their
    // account favorites merged in and the cache replaced with the server view.
    try {
        const startHydrate = function () { hydrateFromServer(); };
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', startHydrate);
        } else {
            // Defer so we don't block the first paint.
            setTimeout(startHydrate, 0);
        }
    } catch (e) {}
})();